import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Configuration API
import './config/api.js'

// Stores
import { useAuthStore } from './stores/auth.js'

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// Styles globaux
import './assets/styles/main.scss'

// Sentry (error tracking)
import * as Sentry from '@sentry/vue'

const app = createApp(App)
const pinia = createPinia()

// Init Sentry (activé seulement si DSN défini)
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN || '',
  environment: process.env.NODE_ENV || (process.env.APP_ENV || 'development'),
  // Tracing désactivé par défaut; activez si besoin
  tracesSampleRate: 0,
})

app.use(pinia)
app.use(router)

// Initialiser l'authentification
const authStore = useAuthStore()
authStore.initializeAuth()

app.mount('#app')
